import React from 'react';
import './badend.scss';

class BadendPage extends React.Component {
	tid = 0;
	constructor(props){
		super(props);
		this.state = {
			list:[],
			fin:false,
		};
	}
	componentDidMount(){
		let n = 0;
		this.tid = setInterval( ()=>{
			let list = this.state.list;
			if( this.props.data.list[n] ){
				list.push( this.props.data.list[n] );
				n++;
			} else {
				list.push( this.props.data.last );
				clearInterval( this.tid );
				this.setState({fin:true});
			}
			this.setState({list:list});
		},250);
	}
	componentWillUnmount (){
		clearInterval( this.tid );
	}
	render (){
		const num = this.props.data.list.length;
		const list = this.state.list.map( (name,index)=>{
			const key = "name"+index;
			let liclass = "";
			const no = index+1;
			if( no===num+1 ){
				liclass = "last";
			}
			return (
				<li key={key} className={liclass}>
					{no}. {name}
				</li>
			);
		})
		return (
			<div id="badend" className="modal">
				<div className="list">
					<p>活動家名簿</p>
					<ul>
						{list}
					</ul>
				</div>
				{this.state.fin &&
				<div className="result">
					<p>{this.props.data.last}の逮捕により、関係者の一斉摘発が開始された。</p>
					<p>おめでとう、今日からきみたちは逃亡者だ。</p>
				</div>
				}
				<div className="arrow"
					onClick={()=>this.close()}
				>
					<p>
						<i className="fas fa-check"></i>
					</p>
				</div>
			</div>
		)
	}

	close (){
		this.props.close();
	}
}

export default BadendPage;